import { Button } from 'ui/Button';
import styles from './ActionRequiredAlertCheque.module.scss';
import { ReactComponent as IconAlert } from './img/iconAlert2.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { useState } from 'react';
import { enumerate } from 'utils/strActions';
// import { enumerate } from 'utils/strActions';

export const ActionRequiredAlertCheque = ({
  count,
  onClick,
}: {
  count: number;
  onClick: () => void;
}) => {
  const [hidden, setHidden] = useState(false);

  if (hidden) return null;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconAlert />
          <div className={styles.header_text}>
            <span className={styles.header_title}>
              Есть непросмотренные аннулированные чеки
            </span>
            <div className={styles.body}>
              <span>
                Нашли {count}{' '}
                {enumerate(count, [
                  'новый аннулированный чек по заказу',
                  'новых аннулированных чека по заказам',
                  'новых аннулированных чеков по заказам',
                ])}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.header_right}>
          <Button
            className={styles.btn}
            onClick={() => {
              onClick();
              setHidden(true);
            }}
            theme='filed'>
            Перейти
          </Button>
          <IconClose style={{ cursor: 'pointer' }} onClick={() => setHidden(true)} />
        </div>
      </div>
    </div>
  );
};
